<template>
    <div class="heading-bar-wrapper flex bg-infill-white rounded-full px-4 py-3 mb-6 justify-between" v-if="step">
        <div class="flex grow items-center">
            <img
                v-if="selectedStep.admin_icon"
                class="mr-2"
                :src="global.app.url + '/images/icons/steps/' + selectedStep.admin_icon + '.svg'"
                :alt="selectedStep.label + ' icon'"
                :title="selectedStep.label"
            />
            <h2 class="text-xl">{{ selectedStep.admin_label }}</h2>
        </div>
        <div v-if="submission.submission != undefined && submission.submission.status != 'Approved' && submission.submission.status != 'Rejected'">
            <a :href="getLinkToStep" target="_blank" class="no-underline"><ButtonComponent color="warning" label="Make Changes" /></a>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ButtonComponent from "@adminComponents/buttons/ButtonComponent";

export default {
    name: "HeadingBarComponent",
    props: {
        heading: { type: String, default: "" }, // Sets the "heading" for the bar
        icon: { type: String, default: "" },
        step: { type: Number, default: 0 },
    },
    components: {
        ButtonComponent,
    },
    computed: {
        ...mapGetters(["global", "stepper", "submission"]),
        selectedStep() {
            return this.stepper.steps[this.step - 1];
        },
        getLinkToStep(){
             let resolvedRoute = this.$router.resolve({
                name: 'create-account',
                params: {step: this.step}
            }); // Resolve the route to get the hyperlink
            return resolvedRoute.href;
        }
    }
};
</script>
